export const chartColor = {
  Axis: '#D5DADF',
  Purple: '#9D74DF',
  LightblueZero: '#00A6CF',
  LightblueZeroFill: '#cff1f9',
  LightblueOne: '#256A7C',
  LightblueTwo: '#1E9DBE',
  GialloDark: '#FFC31A',
  AcquamarineOne: '#39BA7C',
  AcquamarineOneFill: '#CFF8E4',
  AcquamarineTwoLight: '#98EDC9',
  AcquamarineTwo: '#8ACF61',
  AcquamarineThree: '#B0E2C9',
  Grey: '#DDDDDD',
  YellowTwo: '#FFD356',
  YellowThree: '#EEA236',
  LightblueThree: '#69CBE5',
  RedThree: '#FD7F75',
  DarkThree: '#CBCBCB',
  GreenTwo: '#8ACF61'

}

export const RELEASE_DATE_TIME = 1560549600000

export const MAX_DATE_RANGE_DAYS = 90

export const msgInChosenLimit = 100